/* eslint-disable react/jsx-props-no-spreading */
import { ActionIcon, ActionIconProps } from '@mantine/core';
import { FC } from 'react';

type ActionIconPropsColorless = Omit<ActionIconProps, 'color'>;

interface IconProps extends ActionIconPropsColorless, React.ButtonHTMLAttributes<HTMLButtonElement> {}

const ActionIconWithoutFocus: FC<IconProps> = ({ ...props }) => (
  <ActionIcon
    {...props}
    onMouseDown={(e: any) => e.preventDefault()}
    sx={(theme) => ({
      color:
        props.variant === 'filled'
          ? theme.colorScheme === 'dark'
            ? theme.colors.dark[4]
            : 'white'
          : theme.colorScheme === 'dark'
          ? 'white'
          : theme.colors.gray[3],
    })}
  />
);

export const EditorActionIcon: FC<IconProps> = ({ ...props }) => (
  <ActionIcon
    {...props}
    sx={(theme) => ({
      color:
        props.variant === 'filled'
          ? theme.colorScheme === 'dark'
            ? theme.colors.dark[4]
            : 'white'
          : theme.colorScheme === 'dark'
          ? 'white'
          : theme.colors.gray[3],
    })}
  />
);

export default ActionIconWithoutFocus;
